import { ApolloLink } from '@apollo/client'
import { initializeOperationDates } from '../initDates/gqlDateFields'

/**
 * custom Apollo GQL client link responsible for initializing received ISO date strings
 * into proper JS Date objects
 * to work properly, the Record of GQL types & its properties that are of a type Date
 * has to be updated MANUALLY in the file where `GQL_DATE_FIELDS` is defined
 */
export const dateInitLink = new ApolloLink((operation, forward) => {
  const operationResult = forward(operation)

  return operationResult.map((data) => {
    return initializeOperationDates(data)
  })
})
